import React from 'react';
import { MetricDefinitionButton, type MetricDefinition } from '@/components/Dashboard/MetricDefinitionButton';

export type { MetricDefinition };

type MetricLabelProps = {
  label: string;
  metricId: string;
  definicoes: MetricDefinition[];
  className?: string;
  stopPropagation?: boolean;
};

export const MetricLabel: React.FC<MetricLabelProps> = ({
  label,
  metricId,
  definicoes,
  className = '',
  stopPropagation = false,
}) => {
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      {label}
      <MetricDefinitionButton
        metricId={metricId}
        definicoes={definicoes}
        stopPropagation={stopPropagation}
      />
    </span>
  );
};
